'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var React = _interopRequireWildcard(_react);

var _card_component = require('./global_components/card_component.js');

var _card_component2 = _interopRequireDefault(_card_component);

var _table_component = require('./global_components/table_component.js');

var _table_component2 = _interopRequireDefault(_table_component);

var _number_utility = require('../../../packages/common-utilities/src/number_utility.js');

var _number_utility2 = _interopRequireDefault(_number_utility);

var _string_utility = require('../../../packages/common-utilities/src/string_utility.js');

var _string_utility2 = _interopRequireDefault(_string_utility);

var _ramda = require('ramda');

var _functional_utility = require('../../../packages/common-utilities/src/functional_utility.js');

var _functional_utility2 = _interopRequireDefault(_functional_utility);

var _collection_utility = require('common-utilities/src/collection_utility');

var _functional_utility3 = require('../../../packages/common-utilities/src/functional_utility');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ChargesCard = function (_React$Component) {
  _inherits(ChargesCard, _React$Component);

  function ChargesCard(props) {
    _classCallCheck(this, ChargesCard);

    return _possibleConstructorReturn(this, (ChargesCard.__proto__ || Object.getPrototypeOf(ChargesCard)).call(this, props));
  }

  _createClass(ChargesCard, [{
    key: 'getTableRows',
    value: function getTableRows() {
      var _this2 = this;

      var tableRows = [];
      var dataPointShouldShow = function dataPointShouldShow(datapoint) {
        return _collection_utility.CollectionUtility.includes((_this2.props.visibleData || {}).visibleDataPoints, datapoint);
      };

      if (_collection_utility.CollectionUtility.includes((this.props.visibleData || {}).visibleDataPoints, 'JP_ONSHORE_CHARGES_CARD')) {
        this.generateInitialChargesRow(dataPointShouldShow, tableRows, true);
        this.generateManagementChargesRow(dataPointShouldShow, tableRows);
        this.generateRedemptionChargesRow(dataPointShouldShow, tableRows);
      } else if (_collection_utility.CollectionUtility.includes((this.props.visibleData || {}).visibleDataPoints, 'JP_ETF_CHARGES_CARD')) {
        tableRows.push(this.generateCharge("Net Expenses", "pdp-salesChargesCard-net-expense", this.props.expenses.netExpense, "pdp-salesChargesCard-net-expense-percentage-format", "{amount}%"));
      } else {
        this.generateInitialChargesRow(dataPointShouldShow, tableRows);
        this.generateRedemptionChargesRow(dataPointShouldShow, tableRows);
        this.generateManagementChargesRow(dataPointShouldShow, tableRows);
        this.generateTotalExpenseRatioRow(dataPointShouldShow, tableRows);
        this.generateSubscriptionChannelRow(dataPointShouldShow, tableRows);
      }

      return tableRows;
    }
  }, {
    key: 'generateSubscriptionChannelRow',
    value: function generateSubscriptionChannelRow(dataPointShouldShow, tableRows) {
      var subscriptionChannel = this.generateStaticRow("Subscription channel", "pdp-salesChargesCard-subscription-channel", "Cash <br> SRS (for platforms only)", "pdp-salesChargesCard-subscription-channel-cash");

      if (dataPointShouldShow('CHARGES_CARD_SUBSCRIPTION_CHANNEL')) {
        tableRows.push(subscriptionChannel);
      }
    }
  }, {
    key: 'generateManagementChargesRow',
    value: function generateManagementChargesRow(dataPointShouldShow, tableRows) {
      var managementFeeValue = _functional_utility2.default.returnValueOrNull(this.props.fees.managementFee, this.props.fees.managementFee);
      var managementFeeRow = this.generateCharge("Management fee", "pdp-salesChargesCard-management-fee", managementFeeValue, "pdp-salesChargesCard-management-fee-percentage-format", "{amount}% p.a.");

      if (dataPointShouldShow('CHARGES_CARD_MANAGEMENT_FEE') && (!(0, _ramda.isNil)(managementFeeValue) || !dataPointShouldShow('CHARGES_CARD_SUPPRESS_NULL_FEE'))) {
        tableRows.push(managementFeeRow);
      }
    }
  }, {
    key: 'generateRedemptionChargesRow',
    value: function generateRedemptionChargesRow(dataPointShouldShow, tableRows) {
      var formattedRedemtionFee = _functional_utility2.default.returnValueOrNull(this.props.fees.redemptionFees, this.props.fees.redemptionFees);
      var redemptionFeeRowVisibleDataKey = 'CHARGES_CARD_REDEMPTION_FEE';
      var redemptionFeeRow = this.generateCharge("Redemption fee", "pdp-salesChargesCard-redemption-fee", formattedRedemtionFee, "pdp-salesChargesCard-redemption-fee-percentage-format", "{amount}%");

      if (dataPointShouldShow('CHARGES_CARD_CIFM_REDEMPTION_FEE')) {
        redemptionFeeRowVisibleDataKey = 'CHARGES_CARD_CIFM_REDEMPTION_FEE';
        redemptionFeeRow = this.generateCharge("Redemption fee", "pdp-salesChargesCard-redemption-fee", formattedRedemtionFee, "pdp-salesChargesCard-cifm-redemption-fee-percentage-format", "{amount}% (Up to 0.5%)");
      }

      if (dataPointShouldShow(redemptionFeeRowVisibleDataKey) && (!(0, _ramda.isNil)(formattedRedemtionFee) || !dataPointShouldShow('CHARGES_CARD_SUPPRESS_NULL_FEE'))) {
        tableRows.push(redemptionFeeRow);
      }
    }
  }, {
    key: 'generateTotalExpenseRatioRow',
    value: function generateTotalExpenseRatioRow(dataPointShouldShow, tableRows) {
      var formattedTotalExpenseRatio = _functional_utility2.default.returnValueOrNull(this.props.fees.totalExpenseRatio, this.props.fees.totalExpenseRatio);
      var totalExpenseRatioVisibleDataKey = 'CHARGES_CARD_TOTAL_EXPENSE_RATIO';
      var totalExpenseRatioRow = this.generateCharge("Total expense ratio", "pdp-salesChargesCard-total-expense-ratio", formattedTotalExpenseRatio, "pdp-salesChargesCard-total-expense-ratio-percentage-format", "{amount}% p.a.");
      if (dataPointShouldShow(totalExpenseRatioVisibleDataKey) && !(0, _ramda.isNil)(formattedTotalExpenseRatio)) {
        tableRows.push(totalExpenseRatioRow);
      }
    }
  }, {
    key: 'generateInitialChargesRow',
    value: function generateInitialChargesRow(dataPointShouldShow, tableRows) {
      var isDisplayAsItIs = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

      var formattedInitialCharge = void 0;
      if (isDisplayAsItIs) {
        formattedInitialCharge = this.props.fees.subscriptionFees;
      } else {
        formattedInitialCharge = _functional_utility2.default.returnValueOrNull(this.props.fees.subscriptionFees, _number_utility2.default.convertToAmount(this.props.fees.subscriptionFees, 1));
      }
      var initialChargeRowVisibleDataKey = 'CHARGES_CARD_INITIAL_CHARGE';
      var initialChargeTranslationKey = (0, _functional_utility3.doesFormattingRulesContain)('ZERO_VALUE_CHARGES_FORMATTED_FOR_JP_ONSORE', this.props.visibleData, ["formattingRules"]) && formattedInitialCharge === 0 ? "pdp-salesChargesCard-initial-charge-zero-percentage-format" : "pdp-salesChargesCard-initial-charge-percentage-format";
      var initialChargeRow = this.generateCharge("Initial charge", "pdp-salesChargesCard-initial-charge", formattedInitialCharge, initialChargeTranslationKey, "{amount}% of NAV");

      if (dataPointShouldShow('CHARGES_CARD_SUBSCRIPTION_FEE')) {
        initialChargeRowVisibleDataKey = 'CHARGES_CARD_SUBSCRIPTION_FEE';
        initialChargeRow = this.generateCharge("Subscription fee", "pdp-salesChargesCard-subscription-fee", formattedInitialCharge, "pdp-salesChargesCard-initial-charge-percentage-format", "{amount}% of NAV");
      }
      if (dataPointShouldShow('CHARGES_CARD_CIFM_SUBSCRIPTION_FEE')) {
        initialChargeRowVisibleDataKey = 'CHARGES_CARD_CIFM_SUBSCRIPTION_FEE';
        initialChargeRow = this.generateCharge("Subscription fee", "pdp-salesChargesCard-subscription-fee", formattedInitialCharge, "pdp-salesChargesCard-cifm-subscription-charge-percentage-format", "Up to {amount}% of NAV");
      }
      if (dataPointShouldShow(initialChargeRowVisibleDataKey) && (!(0, _ramda.isNil)(formattedInitialCharge) || !dataPointShouldShow('CHARGES_CARD_SUPPRESS_NULL_FEE'))) {
        tableRows.push(initialChargeRow);
      }
    }
  }, {
    key: 'generateCharge',
    value: function generateCharge(defaultLabel, labelKey, dataValue, dataFormatKey, defaultFormat) {

      var chargeValue = (0, _ramda.isNil)(dataValue) ? _string_utility2.default.renderFormattedLabel("Nil", "nil-value") : _string_utility2.default.renderFormattedLabel(defaultFormat, dataFormatKey, { amount: dataValue });

      return React.createElement(
        'tr',
        { 'data-testid': labelKey + '-row', id: labelKey + '-row',
          className: 'portfolio-override-bold category row-divider',
          key: labelKey + '-key' },
        React.createElement(
          'td',
          { key: '0', colSpan: 2, className: 'text-left',
            'data-testid': 'charges-child-name' },
          _string_utility2.default.renderFormattedLabel(defaultLabel, labelKey)
        ),
        React.createElement(
          'td',
          { key: '1', className: 'text-right',
            'data-testid': 'charges-child-value' },
          chargeValue
        )
      );
    }
  }, {
    key: 'generateStaticRow',
    value: function generateStaticRow(defaultLabel, labelKey, dataLabel, dataLabelKey) {
      return React.createElement(
        'tr',
        { 'data-testid': labelKey + '-row', id: labelKey + '-row',
          className: 'portfolio-override-bold category row-divider',
          key: labelKey + '-key' },
        React.createElement(
          'td',
          { key: '0', colSpan: 2, className: 'text-left',
            'data-testid': 'charges-child-name' },
          _string_utility2.default.renderFormattedLabel(defaultLabel, labelKey)
        ),
        React.createElement(
          'td',
          { key: '1', className: 'text-right',
            'data-testid': 'charges-child-value' },
          _string_utility2.default.renderFormattedHTMLLabel(dataLabel, dataLabelKey)
        )
      );
    }
  }, {
    key: 'render',
    value: function render() {
      var feesDataDoesNotExist = (0, _ramda.isNil)(this.props.fees.subscriptionFees) && (0, _ramda.isNil)(this.props.fees.redemptionFees) && (0, _ramda.isNil)(this.props.fees.managementFee);
      var expenseDataExist = !(0, _ramda.isNil)((this.props.expenses || {}).netExpense) && _collection_utility.CollectionUtility.includes((this.props.visibleData || {}).visibleDataPoints, 'JP_ETF_CHARGES_CARD');
      if (feesDataDoesNotExist && !expenseDataExist) {
        return null;
      }
      var chargesLabel = _string_utility2.default.renderFormattedLabel("CHARGES", "pdp-salesChargesCard-label");
      return React.createElement(
        _card_component2.default,
        {
          headerTitle: chargesLabel,
          headerTitleId: "chargesCard",
          headerTitleLabel: "",
          breakpoint: this.props.breakpoint,
          headerLabel: "",
          disclosureText: (0, _ramda.pathOr)(null, ["disclosures", "pdpCardCharges"], this.props),
          placementId: "pdpCardCharges",
          style: this.props.breakpoint < 3 ? { "padding-left": "16px", "padding-right": "16px" } : {}
        },
        React.createElement(_table_component2.default, {
          tableRows: this.getTableRows(),
          breakpoint: this.props.breakpoint,
          tableBodyTest: ''
        })
      );
    }
  }]);

  return ChargesCard;
}(React.Component);

exports.default = ChargesCard;